module.exports = __webpack_public_path__ + "media/img/vca/sponsors/anjalichocolat-913ce3de9bb29f7a759447183588d440.png";